function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import { Table, Tabs } from 'antd';
import React, { useState } from 'react';
import { fetchUserSaleData } from '../../cores/api/api-dashboard';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { formatCountNumber } from '../../utils/format-data';
const thisYearData = Array.from({
    length: 12
}, (_, index) => {
    const month = 12 - index;
    return {
        key: index + 1,
        period: `2024年${month.toString().padStart(2, '0')}月`,
        account: 1000,
        email: 180,
        profile: 100,
        subscribe: 80,
        like: 50
    };
});
const lastYearData = Array.from({
    length: 12
}, (_, index) => {
    const month = 12 - index;
    return {
        key: index + 1,
        period: `2023年${month.toString().padStart(2, '0')}月`,
        account: 900,
        email: 150,
        profile: 90,
        subscribe: 70,
        like: 45
    };
});
const columns = [{
        title: '#',
        dataIndex: 'month',
        width: 60,
        render: (_value, _record, index) => index + 1
    }, {
        title: '期間',
        dataIndex: 'month_name',
        key: 'month_name'
    }, {
        title: 'アカウント登録',
        dataIndex: 'registration_count',
        key: 'registration_count',
        align: 'center',
        width: 200,
        render: val => formatCountNumber(val)
    }, {
        title: 'メール確認',
        dataIndex: 'email_verify_count',
        key: 'email_verify_count',
        align: 'center',
        width: 200,
        render: val => formatCountNumber(val)
    }, {
        title: 'プロフィール入力',
        dataIndex: 'complete_profile_count',
        key: 'complete_profile_count',
        align: 'center',
        width: 200,
        render: val => formatCountNumber(val)
    }, {
        title: 'サブスク',
        dataIndex: 'sales_subscription_count',
        key: 'sales_subscription_count',
        align: 'center',
        width: 200,
        render: val => formatCountNumber(val)
    }, {
        title: 'いいね',
        dataIndex: 'sales_like_count',
        key: 'sales_like_count',
        align: 'center',
        width: 200,
        render: val => formatCountNumber(val)
    }];
export default function SectionUserSaleData() {
    var _a;
    const _useState = useState('this'), _useState2 = _slicedToArray(_useState, 2), activeTab = _useState2[0], setActiveTab = _useState2[1];
    const _useState3 = useState({
        page: 1,
        per_page: 12,
        year: dayjs().year(),
        sort_by: 'month',
        order: 'desc'
    }), _useState4 = _slicedToArray(_useState3, 2), params = _useState4[0], setParams = _useState4[1];
    const _useQuery = useQuery({
        queryKey: ['fetchUserSaleData', params],
        queryFn: () => fetchUserSaleData(params),
        keepPreviousData: true,
        staleTime: 60 * 1000
    }), data = _useQuery.data, isFetching = _useQuery.isFetching, isLoading = _useQuery.isLoading;
    const handleTabChange = key => {
        setActiveTab(key);
        const year = key === 'this' ? dayjs().year() : dayjs().year() - 1;
        setParams(prev => _objectSpread(_objectSpread({}, prev), {}, {
            year
        }));
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "bg-white p-4 rounded-lg shadow-sm"
    }, /*#__PURE__*/ React.createElement(Tabs, {
        defaultActiveKey: "this",
        activeKey: activeTab,
        onChange: handleTabChange,
        items: [{
                key: 'this',
                label: /*#__PURE__*/ React.createElement("span", {
                    className: "text-yellow-500 font-semibold text-xl"
                }, "\u4ECA\u5E74")
            }, {
                key: 'last',
                label: /*#__PURE__*/ React.createElement("span", {
                    className: "text-gray-700 font-medium text-xl"
                }, "\u524D\u5E74")
            }],
        className: "mb-4"
    }), /*#__PURE__*/ React.createElement(Table, {
        className: isFetching ? 'opacity-60 transition-opacity' : '',
        rowKey: "month",
        loading: isFetching,
        dataSource: (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : [],
        columns: columns,
        pagination: false,
        bordered: true,
        size: "middle"
    }));
}
